__turbopack_context__.v({
  "download": "RichTextDownload-module-scss-module__po473W__download",
});
